import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=ed1ec10a"
import script from "./LogoIcon.vue?vue&type=script&lang=js"
export * from "./LogoIcon.vue?vue&type=script&lang=js"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=ed1ec10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports